import React, { useEffect, useState } from "react";
import { useOIDC } from "./OIDCProvider";
import {
  clearLoggedOut,
  isLoggedOutLanding,
  isLogoutInProgress,
  resetAuthNavigation,
} from "../services/oidc";

interface AuthWrapperProps {
  children: React.ReactNode;
}

/**
 * Ensures the user is authenticated. Unauthenticated users are sent to Keycloak
 * login (same behavior as before). No intermediate "logged out" page.
 */
const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { isAuthenticated, isLoading, login } = useOIDC();
  const [redirectStarted, setRedirectStarted] = useState(false);

  useEffect(() => {
    // Back from Keycloak logout: clear the flag so normal auto-login can run
    if (isLoggedOutLanding()) {
      clearLoggedOut();
      resetAuthNavigation();
    }
  }, []);

  useEffect(() => {
    // Don't start login while Keycloak logout navigation is still in flight
    if (
      isLoading ||
      isAuthenticated ||
      redirectStarted ||
      isLogoutInProgress()
    ) {
      return;
    }
    setRedirectStarted(true);
    login();
  }, [isLoading, isAuthenticated, redirectStarted, login]);

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        color: "#333",
      }}
    >
      {isLoading ? "Checking authentication..." : "Redirecting to login..."}
    </div>
  );
};

export default AuthWrapper;
